import { Alert as MuiAlert, Snackbar } from "@mui/material";

const Alert = (props) => {
  const { open, severity, message, anchor, onClose, duration = 3000 } = props;

  return (
    <Snackbar open={open} autoHideDuration={duration} anchorOrigin={anchor}>
      <MuiAlert onClose={onClose} severity={severity}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Alert;
